import React from 'react';
import { connect } from 'react-redux';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE, AUTH_PROFILE_AML_LEVEL } from 'apps/auth/constants/UrlConstants';
import { isSpecialCountry } from 'apps/auth/helpers/utils';

const ProfileAmlLimitsPage = (props) => {
    const getAmlIcon = (currentBiggerThanAml, amlId) => {
        switch (amlId) {
            case 0:
                return 'balloon';
            case 1:
                return 'flag';
            case 2:
                return 'zap';
            case 3:
                return 'speedometer';
            default:
                return 'speedometer';
        }
    };
    const getSpecialAmlIcon = (currentBiggerThanAml, amlId) => {
        switch (amlId) {
            case 0:
                return 'balloon';
            case 1:
                return 'zap';
            case 2:
                return 'speedometer';
            case 3:
                return 'speedometer';
            default:
                return 'speedometer';
        }
    };

    return (
        <CommonPage showChat={false} backUrl={AUTH_PROFILE}>
            <HeaderPanel title={props.headerTitle} />
            {props.profileForm &&
                props.profileForm.amlLimit &&
                Array.isArray(props.profileForm.amlLimit.amlLimitLevels) &&
                props.profileForm.amlLimit.amlLimitLevels.map((aml) => {
                    const currectUrl = `${AUTH_PROFILE_AML_LEVEL}/${aml.id}/info`;
                    let currentBiggerThanAml = props.profileForm.amlLimit.currentLimit >= aml.id && aml.id < 3;

                    if (isSpecialCountry(props.userCountry)) {
                        currentBiggerThanAml = props.profileForm.amlLimit.currentLimit >= aml.id && aml.id < 2;
                    }

                    return (
                        <Row indent="adaptive-24-32" key={`aml-info-${aml.id}`}>
                            <Panel
                                type="reactLink"
                                isDisabled={currentBiggerThanAml}
                                to={currentBiggerThanAml ? '#top' : currectUrl}
                                isBordered
                                hasBorderRadius
                            >
                                <PanelFrame>
                                    <DiskBadgeWrapper>
                                        <DiskBadge
                                            variant={currentBiggerThanAml ? 'tertiary' : 'secondary'}
                                            isInactive={currentBiggerThanAml}
                                            iconName={
                                                isSpecialCountry ? getSpecialAmlIcon(currentBiggerThanAml, aml.id) : getAmlIcon(currentBiggerThanAml, aml.id)
                                            }
                                        />
                                    </DiskBadgeWrapper>
                                    <PanelContent>
                                        <PanelRow>
                                            <Text color={currentBiggerThanAml ? 'secondary' : 'primary'} ellipsis>
                                                {
                                                    props.messages[
                                                        (isSpecialCountry(props.userCountry) ? 'profileSpecialAmlLimitLevel_' : 'profileAmlLimitLevel_') +
                                                            aml.id
                                                    ]
                                                }
                                            </Text>
                                        </PanelRow>
                                        {props.profileForm.amlLimit.currentLimit === aml.id && (
                                            <PanelRow>
                                                <Text size="secondary" color="secondary" ellipsis>
                                                    {props.profileAmlCurrent}
                                                </Text>
                                            </PanelRow>
                                        )}
                                    </PanelContent>
                                    <PanelRightBlock>
                                        <PanelRow alignEnd>
                                            <Text color={currentBiggerThanAml ? 'secondary' : 'primary'}>
                                                {aml.id === 0 && props.profileAmlZero}
                                                {aml.id === 1 && props.profileAmlFirst}
                                                {aml.id === 2 && props.profileAmlSecond}
                                                {aml.id === 3 && props.profileAmlThird}
                                            </Text>
                                        </PanelRow>
                                        <PanelRow alignEnd>
                                            <Text color={currentBiggerThanAml ? 'secondary' : 'primary'}>
                                                {props.messages['profileCountryAmlLimitLevel_' + aml.id]}
                                            </Text>
                                        </PanelRow>
                                    </PanelRightBlock>
                                </PanelFrame>
                            </Panel>
                        </Row>
                    );
                })}
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        profileForm: state.extra.profile_form,
        userCountry: state.auth.countryId,
        messages: state.messages.pageMessages,
        headerTitle: state.messages.pageMessages.headerTitle,
        profileAmlCurrent: state.messages.pageMessages.profileAmlCurrent,
        profileAmlZero: state.messages.pageMessages.profileAmlZero,
        profileAmlFirst: state.messages.pageMessages.profileAmlFirst,
        profileAmlSecond: state.messages.pageMessages.profileAmlSecond,
        profileAmlThird: state.messages.pageMessages.profileAmlThird,
    };
};
export default connect(mapStateToProps)(BasePage(ProfileAmlLimitsPage));
